import { jsxs, jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import './FinanceProgram.css';import '../Grid/Grid.css';/* empty css                */
import Icon from "../Icon/Icon.js";
import Price from "../Price/Price.js";
import Typography from "../Typography/Typography.js";
/* empty css                    */
const FinanceProgramPrice = ({
  label,
  text,
  className
}) => {
  return /* @__PURE__ */ jsxs(Row, { className: classnames("perxis-auto-finance-program-price", className), gutter: [0, "vertical-purple"], children: [
    /* @__PURE__ */ jsx(Col, { className: "gutter-row", span: 24, children: /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "dark-light", className: classnames("perxis-auto-finance-program-price-label"), children: label }) }),
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(Row, { wrap: false, justify: "space-between", children: [
      /* @__PURE__ */ jsx(Col, { flex: "auto", children: /* @__PURE__ */ jsx(Price, { value: text, className: classnames("perxis-auto-finance-program-price__price") }) }),
      /* @__PURE__ */ jsx(Col, { flex: "none", children: /* @__PURE__ */ jsx(
        Typography.Text,
        {
          level: "small",
          color: "light",
          className: classnames("perxis-auto-finance-program-price__check-icon"),
          children: /* @__PURE__ */ jsx(Icon, { name: "check", sticker: "finance-program-price-check-icon", size: 24 })
        }
      ) })
    ] }) })
  ] });
};
export {
  FinanceProgramPrice as default
};
//# sourceMappingURL=FinanceProgramPrice.js.map
